/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerWarnings
 */
export interface GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerWarnings {
    /**
     * 
     * @type {string}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerWarnings
     */
    'detectedDpi'?: GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerWarningsDetectedDpiEnum;
    /**
     * 
     * @type {string}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerWarnings
     */
    'calculatedDpi'?: GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerWarningsCalculatedDpiEnum;
    /**
     * 
     * @type {string}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerWarnings
     */
    'colorGradation'?: GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerWarningsColorGradationEnum;
    /**
     * 
     * @type {string}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerWarnings
     */
    'heightMillis'?: GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerWarningsHeightMillisEnum;
    /**
     * 
     * @type {string}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerWarnings
     */
    'widthMillis'?: GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerWarningsWidthMillisEnum;
}

export const GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerWarningsDetectedDpiEnum = {
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerWarningsDetectedDpiEnum = typeof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerWarningsDetectedDpiEnum[keyof typeof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerWarningsDetectedDpiEnum];
export const GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerWarningsCalculatedDpiEnum = {
    pixelsInsufficient: 'PIXELS_INSUFFICIENT',
    pixelsRequired: 'PIXELS_REQUIRED',
    realSizeRequired: 'REAL_SIZE_REQUIRED',
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerWarningsCalculatedDpiEnum = typeof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerWarningsCalculatedDpiEnum[keyof typeof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerWarningsCalculatedDpiEnum];
export const GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerWarningsColorGradationEnum = {
    required: 'REQUIRED',
    insufficient: 'INSUFFICIENT'
} as const;

export type GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerWarningsColorGradationEnum = typeof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerWarningsColorGradationEnum[keyof typeof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerWarningsColorGradationEnum];
export const GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerWarningsHeightMillisEnum = {
    required: 'REQUIRED'
} as const;

export type GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerWarningsHeightMillisEnum = typeof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerWarningsHeightMillisEnum[keyof typeof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerWarningsHeightMillisEnum];
export const GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerWarningsWidthMillisEnum = {
    required: 'REQUIRED'
} as const;

export type GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerWarningsWidthMillisEnum = typeof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerWarningsWidthMillisEnum[keyof typeof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerEvidenceListInnerWarningsWidthMillisEnum];


